export const transportationTypes = {
    bus: "bus",
    ferry: "ferry",
}